import { Link, Card, CardContent, CardMedia, Grid, makeStyles, Typography } from '@material-ui/core'
import mockData from "../mockData"
import React from 'react'


const Myworks = ({}) => {
    const classes = useStyles();
    return (
        
        <div className ={`${classes.section} ${classes.sectiondark}`}>
        <div className={classes.sectioncontent}>

                <Grid container className={classes.grid}>
                    {
                        mockData.map(({title, image, link}, index)=>(
                            <Grid item key ={index} xs={12} sm={6} md={6}>
                                <Card className={classes.card}>`
                                     <CardMedia className={classes.thumbnail} image={image} titulo="thumbnail"/>
                                    <div className={classes.overlay}> 
                                        <div className={classes.transparent}></div>
                                   <CardContent className={classes.cardtext}>
                                        <Link  className={classes.title} href={link}  target="_blank" rel="noopener noreferrer">
                                           {title}
                                            </Link>
                                   </CardContent>
                                    </div>`
                                 
                                </Card>
                            </Grid>
                        ))
                    }
                </Grid>
            </div>
    </div>
    )
}

const useStyles = makeStyles((theme) => ({
    section: {
        minHeight: "100vh"
    },
    titlesection:{
        fontFamily: "'Playfair Display', serif;",
        paddingTop: "2rem",
         [theme.breakpoints.down('sm')]:{
            padding: "20px 0px",
            fontSize:"2rem"
        }
        
    },
    
    sectioncontent:{
        maxWidth: "9vw",
        margin: "0 auto",
        padding: theme.spacing(5),
        [theme.breakpoints.down('sm')]:{
            padding: theme.spacing(2),

           
        }
    },
 
    sectioncontent:{
        maxWidth: "100vw",
        margin: "0 auto"
    },
    grid:{
        marginTop: "0px",
      
    },
    card: {
        maxWidth:'50vw', 
        minHeight: '202px',
        height:'470px',
        borderRadius:"0px",
        position:'relative',
        '&:hover .thumbnail':{
         filter: 'blur(30px)',
         filter: 'grayscale(100%)',

        },
          [theme.breakpoints.down('sm')]:{
           maxWidth:'100vw',

           
        }
    },
    thumbnail:{
        width:'100%',
        height:'100%',
        marginTop:'-24px',
        zIndex: '1',
        transition:'0.5s',
        '&:hover':{
                 filter: 'grayscale(100%)',
                 filter: 'blur(3px)',
                 backgroundColor:'#df99c155'
        }

    },
    cardtext:{
        backgroundColor:'#df99c1',
        height:'499px',
        width:'100%',
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        
    },
    overlay:{
        display:'block',
        position:'absolute',
        bottom:'0',
        height:'100%',
        width:'100%',
        transition:'0.5s',
        '&:hover':{
            transform:'translateY(-500px)',
        },
        '&:hover .thumbnail':{
            zIndex:'-2'
   
           },

    },
    transparent:{
        height:'490px',
        top:'0',
        backgroundColor:'transparent',
        opacity:'0.5',
    },
    title:{
        color:'white',
        fontSize:'3em',
        zIndex:'1',
        fontWeight:'200',
        padding:'250px 100px',
        '&:hover':{
            textDecoration:'none',
            
        }
    }

}))

export default Myworks


// {//*  .omar{
//     background-color: blueviolet;
//     width: 400px;
//     height: 400px;
//     background-image: url(./omar.jpg);
//     background-repeat: no-repeat;
//     background-size: cover;
//     background-position-y: 400px;
//     transition: 0.6s;
//     margin: 100px auto;
// }
// .omar:hover{
//     background-position-y:0;

// }*//}